// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__16A5O","actionsCol":"EnrolledClinics_actionsCol__xLY5I"};